<template>
  <v-col cols="12">
    <v-row column v-if="banner.id">
      <v-col cols="12">
        <v-card>
          <v-card-title primary-title>
            <img :src="banner.main_article.cover.url || ''" />
            {{ banner.main_article.title }}
          </v-card-title>
        </v-card>
      </v-col>

      <v-col lg4>
        <v-card>
          <v-card-title primary-title>
            <img :src="banner.article_1.cover.url || ''" />
            {{ banner.article_1.title }}
          </v-card-title>
        </v-card>
      </v-col>
      <v-col lg4>
        <v-card>
          <v-card-title primary-title>
            <img :src="banner.article_2.cover.url || ''" />
            {{ banner.article_2.title }}
          </v-card-title>
        </v-card>
      </v-col>
      <v-col lg4>
        <v-card>
          <v-card-title primary-title>
            <img :src="banner.article_3.cover.url || ''" />
            {{ banner.article_3.title }}
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-btn
      v-show="createMode"
      dark
      bottom
      right
      fab
      color="secondary"
      style="top: 30px"
      :to="{ name: 'banners_create' }"
    >
      <v-icon dark>add</v-icon>
    </v-btn>
  </v-col>
</template>

<script>
export default {
  name: 'banners_list',
  data() {
    const defaultBanner = {
      main_article: {
        cover: { url: '' },
        title: '',
      },
      article_1: {
        cover: { url: '' },
        title: '',
      },
      article_2: {
        cover: { url: '' },
        title: '',
      },
      article_3: {
        cover: { url: '' },
        title: '',
      },
    }

    let banner = { ...defaultBanner }
    return {
      banner: banner,
      defaultBanner: defaultBanner,
      createMode: false,
    }
  },
  watch: {
    '$attrs.site_key': function () {
      this.updateData()
    },
  },
  mounted() {
    this.updateData()
  },
  update() {
    this.updateData()
  },
  methods: {
    updateData() {
      this.axios({
        url: `/v1/banners/${this.$attrs.site_key}`,
        method: 'get',
      })
        .then((resp) => {
          if (resp.status === 204) {
            this.banner = { ...this.defaultBanner }
            this.createMode = true
          } else {
            this.banner = resp.data
            this.createMode = !resp.data
          }
          this.$log.debug(resp, resp.status)
        })
        .catch((err) => {
          this.showSnackbar(err.response.data)
        })
    },
  },
}
</script>
